import { render, staticRenderFns } from "./physioData.vue?vue&type=template&id=3832d496&scoped=true"
import script from "./physioData.vue?vue&type=script&lang=js"
export * from "./physioData.vue?vue&type=script&lang=js"
import style0 from "./physioData.vue?vue&type=style&index=0&id=3832d496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832d496",
  null
  
)

export default component.exports